import CreatableSelect from 'react-select/creatable';
import { doubleStyles, toSelectFormat } from './utils';

const MileageFilter = ({
  mileageOptions,
  selectValues,
  mileageConfig,
  handleChange,
  isSelectedFormat = true,
  placeholders,
}) => {
  const validateMileageFrom = from => {
    const min = mileageConfig.minimum;
    const max = mileageConfig.maximum;
    const to = selectValues.mileageToOption || max;
    console.log(from, to);
    if (from < min || from > max || from > to) {
      handleChange('mileageFromOption', null);
    } else {
      handleChange('mileageFromOption', isSelectedFormat ? toSelectFormat(from) : from);
    }
  };

  const validateMileageTo = to => {
    const min = mileageConfig.minimum;
    const max = mileageConfig.maximum;
    const from = selectValues.mileageFromOption || min;
    if (to < min || to > max || to < from) {
      handleChange('mileageToOption', null);
    } else {
      handleChange('mileageToOption', isSelectedFormat ? toSelectFormat(to) : to);
    }
  };
  return (
    <div className="double__select">
      <CreatableSelect
        options={mileageOptions}
        placeholder={placeholders ? 'Desde' : 'Kilometraje desde'}
        styles={doubleStyles}
        onCreateOption={value => validateMileageFrom(value)}
        value={toSelectFormat(selectValues.mileageFromOption)}
        onChange={selectedOption => validateMileageFrom(selectedOption.value)}
        classNamePrefix="select"
        formatCreateLabel={inputValue => `${inputValue} km`}
      />
      <CreatableSelect
        options={mileageOptions}
        placeholder={placeholders ? 'Hasta' : 'Kilometraje hasta'}
        styles={doubleStyles}
        onCreateOption={value => validateMileageTo(value)}
        value={toSelectFormat(selectValues.mileageToOption)}
        onChange={selectedOption => validateMileageTo(selectedOption.value)}
        classNamePrefix="select"
        formatCreateLabel={inputValue => `${inputValue} km`}
      />
    </div>
  );
};

export default MileageFilter;
